export class DirectUploadQueue {
  constructor() {
    this.uploads = [];
    this.uploadsPending = 0;
    this.changeEvent = new Event("change");
  }

  push(upload) {
    this.uploads.push(upload);
  }

  flush() {
    /*
        Upload all files pending for direct upload
        and then resolve the promise once done
     */
    return new Promise((resolve, reject) => {
      this.uploadsPending = this.uploads.length;
      if (!this.uploadsPending) resolve();

      const cleanUp = () => {
        document.removeEventListener('direct-upload-callback-completed', onUploadCompleted);
        document.removeEventListener('direct-upload-callback-failed', onUploadFailed);
      };

      const onUploadCompleted = () => {
        this.uploadsPending -= 1;
        if (!this.uploadsPending) {
          this.uploads = [];
          cleanUp();
          resolve();
        }
      };

      const onUploadFailed = () => {
        this.uploads = [];
        cleanUp();
        reject();
      };

      document.addEventListener('direct-upload-callback-completed', onUploadCompleted);
      document.addEventListener('direct-upload-callback-failed', onUploadFailed);

      for (const upload of this.uploads) {
        const { uploader, file } = upload;
        $(uploader).S3Uploader();
        const fileInput = uploader.querySelector('input[type="file"]');
        this.#performUpload(file, fileInput);
      }
    });
  }

  #performUpload = (file, fileInput) => {
    /*
        Manually assigning s3 form upload the required file
        and triggering the upload.
     */
    Object.defineProperty(fileInput, "files", {
      value: [file],
    });
    fileInput.dispatchEvent(this.changeEvent);
  }
}
